import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative w-full min-h-[500px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20lifestyle%20photography%20of%20a%20curated%20walk%20in%20closet%20or%20dressing%20room%20with%20open%20wooden%20shelves%20displaying%20folded%20clothes%20leather%20accessories%20and%20woven%20baskets%20a%20cozy%20reading%20chair%20nearby%20warm%20golden%20afternoon%20light%20streaming%20through%20linen%20curtains%20cream%20and%20terracotta%20color%20palette%20editorial%20interior%20design%20photography%20inviting%20atmosphere&width=1800&height=1000&seq=cta-bg-v2&orientation=landscape"
        alt="Warm lifestyle shopping scene with curated fashion products in cozy interior setting"
        title="Shop Kakobuy Spreadsheet Finds"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-black/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 text-center">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-extrabold text-background-50 uppercase tracking-wide mb-4">
          Ready To Shop Smarter?
        </h2>
        <p className="text-base md:text-lg text-background-50/85 max-w-lg mx-auto leading-relaxed mb-8">
          Join thousands of buyers using our curated Kakobuy Spreadsheet. Access the latest finds, compare prices instantly, and shop with confidence.
        </p>
        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="group inline-flex items-center gap-3 px-8 py-4 bg-foreground-900 text-background-50 rounded-full hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500 text-background-50 flex-shrink-0">
            <i className="ri-shopping-bag-line text-base"></i>
          </span>
          <span className="text-sm font-semibold uppercase tracking-wide">
            Visit Kaspreadsheet.com
          </span>
          <i className="ri-arrow-right-up-line text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200"></i>
        </a>
      </div>
    </section>
  );
}